import { STHYPE_ADDRESS, STHYPE_OVERSEER_ADDRESS } from '@hyperswap/addresses'

export const MAINTENANCE_IS_ACTIVATED = false
export const EARN_STHYPE_IS_DISABLED = !STHYPE_ADDRESS || !STHYPE_OVERSEER_ADDRESS
